import script from "./ShowUserView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowUserView.vue?vue&type=script&setup=true&lang=ts"

import "./ShowUserView.vue?vue&type=style&index=0&id=5a545222&lang=scss"

const __exports__ = script;

export default __exports__